export const chunkString = (str: string, size: number) => {
    const chunkRegExp = new RegExp('.{1,' + size + '}', 'g');

    return str.match(chunkRegExp);
};
